import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const jiraSyncPlugin = createPlugin({
  id: 'jira-sync',
  routes: {
    root: rootRouteRef,
  },
});

export const JiraSyncPage = jiraSyncPlugin.provide(
  createRoutableExtension({
    name: 'JiraSyncPage',
    component: () =>
      import('./components/UtilPage').then(m => m.UtilPage),
    mountPoint: rootRouteRef,
  }),
);
